export const EVENT_CREATE_MODE = {
  ALBUM: 'ALBUM',
  GALLERY: 'GALLERY',
};

export const ALBUM_STANDALONE_SELECT_VALUE = 'ALBUM_STANDALONE_SELECT_VALUE';
export const ALBUM_FOLDER_SELECT_CREATE_NEW = 'ALBUM_FOLDER_SELECT_CREATE_NEW';
